import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import {
  ITerminology,
  sentenceCase
} from "src/library/utils";
import { IDrop } from "src/core/drops/api/drops.api";

/**
 * This function returns a reusable formated column definition for customer data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for customer data
 */
export const dropColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
  column: Partial<Pick<DisplayColumnDef<TData>, "id" | "enableColumnFilter" | "meta">>,
  terminology: ITerminology
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: "branch",
    filterType: "string",
    header: `${sentenceCase(terminology.drop.singular.text)}`,
    cell: info => {
      if (info.getValue()) {
        const drop = info.getValue() as IDrop;

        if (drop) {
          return `(${drop.branchNumber}) ${drop.name}`;
        }
      }

      return "-";
    },
    enableSorting: false,
    enableColumnFilter: true,
    enableResizing: true,
    minSize: 100,
    meta: {
      style: { align: "left" },
      filter: column.meta?.filter ? column.meta?.filter : {
        filterType: "string",
        minLength: 3
      }
    }
  } as DisplayColumnDef<TData>);
};
